import { render } from "./SlidesWithControls.vue?vue&type=template&id=04e5277e&ts=true"
import script from "./SlidesWithControls.vue?vue&type=script&lang=ts"
export * from "./SlidesWithControls.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__